import { mapActions, mapGetters } from 'vuex'
import Api from '@/../app-common-vue/src/lib/Api'

export default {
  apiInstance: null,
  computed: {
    ...mapGetters(['currentUser', 'currentRoom', 'viewNewChatFlg', 'currentMailRoom', 'viewNewMailChatFlg']),

    api () {
      if (this.$options.apiInstance === null) {
        let authToken = this.currentUser ? this.currentUser.accessToken : null
        this.$options.apiInstance = new Api(authToken)

        if (this.$route.path.startsWith('/user/mail') && this.currentMailRoom) {
          this.$options.apiInstance.roomAccessToken = this.currentMailRoom.accessToken
        } else if (this.currentRoom) {
          this.$options.apiInstance.roomAccessToken = this.currentRoom.accessToken
        }

        this.$options.apiInstance.onSessionExpired = () => {
          // セッション期限切れの場合
          this.setCurrentUser(null)
          this.$router.push({ name: 'Top' })
        }
      }
      return this.$options.apiInstance
    }
  },
  watch: {
    currentUser (newUser) {
      // auth token変更されたらApiインスタンス再作成
      this.$options.apiInstance = null
    },
    currentRoom (newRoom) {
      // 現在のルームが変更されたらルーム認証トークンを更新
      if (newRoom !== null && this.$options.apiInstance !== null) {
        this.$options.apiInstance.roomAccessToken = newRoom.accessToken
      }
    },
    currentMailRoom (newRoom) {
      // 現在のルームが変更されたらルーム認証トークンを更新
      if (newRoom !== null && this.$options.apiInstance !== null) {
        this.$options.apiInstance.roomAccessToken = newRoom.accessToken
      }
    }
  },
  methods: {
    ...mapActions(['setCurrentUser', 'setCurrentRoom', 'setViewNewChatFlg', 'setCurrentMailRoom', 'setviewNewMailChatFlg']),

    // ログイン → チャット画面へ遷移
    login (userId, password) {
      this.api.login(userId, password, 'user').then(res => {
        this.setCurrentUser(res.data)
        this.$router.push({name: 'Chat'})
      })
      .catch(err => {
        if (err.response && err.response.status === 401) {
          this.errMessage = 'ユーザーIDもしくはパスワードに誤りがあります。'
          this.visibleErrMessage = true
        } else {
          this.handleError('ログインに失敗しました。', err)
        }
      })
    },

    // ログアウト → トップ画面へ
    logout () {
      this.api.logout().then(res => {
        this.setCurrentUser(null)
        this.setCurrentRoom(null)
        this.setCurrentMailRoom(null)
        this.$router.push({name: 'Top'})
      })
      .catch(err => {
        this.handleError('ログアウトに失敗しました。', err)
      })
    },

    /*
     * 汎用エラーハンドリング
     */
    handleError (msg, err) {
      if (process.env.NODE_ENV === 'production' || err === null) {
        alert(msg)
      } else {
        console.log(err)
        alert(`${msg} (${err})`)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BaseComponent.js